module.exports = "<div class=\"container-fluid footer\">\r\n  <p>Fire Island Terminal Inc. | Season Parking 2023 | Version: 1.2.41</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 55
// module chunks = 0